/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  InAppProductsUserControllerFindAllQueryResponse,
  InAppProductsUserControllerFindAllPathParams,
  InAppProductsUserControllerFindAll401,
} from '../../types/InAppProductsUserControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { inAppProductsUserFindAll } from '../../methods/inAppProductsUserFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const inAppProductsUserFindAllQueryKey = (platform: InAppProductsUserControllerFindAllPathParams['platform']) =>
  [{ url: '/api/user/in-app-products/:platform', params: { platform: platform } }] as const;

export type InAppProductsUserFindAllQueryKey = ReturnType<typeof inAppProductsUserFindAllQueryKey>;

export function inAppProductsUserFindAllQueryOptions(
  platform: InAppProductsUserControllerFindAllPathParams['platform'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = inAppProductsUserFindAllQueryKey(platform);
  return queryOptions<
    InAppProductsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<InAppProductsUserControllerFindAll401>,
    InAppProductsUserControllerFindAllQueryResponse,
    typeof queryKey
  >({
    enabled: !!platform,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return inAppProductsUserFindAll(platform, config);
    },
  });
}

/**
 * {@link /api/user/in-app-products/:platform}
 */
export function useInAppProductsUserFindAll<
  TData = InAppProductsUserControllerFindAllQueryResponse,
  TQueryData = InAppProductsUserControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = InAppProductsUserFindAllQueryKey,
>(
  platform: InAppProductsUserControllerFindAllPathParams['platform'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        InAppProductsUserControllerFindAllQueryResponse,
        ResponseErrorConfig<InAppProductsUserControllerFindAll401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? inAppProductsUserFindAllQueryKey(platform);

  const query = useQuery(
    {
      ...inAppProductsUserFindAllQueryOptions(platform, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<InAppProductsUserControllerFindAll401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
